import React from 'react';
import { IconContainer } from './IconContainer';

const SortBlockArrowIcon = ({ descend, ...props }) => {
    return (
        <IconContainer ariaLabel="sort-arrow" style={{ cursor: "pointer" }} {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                {descend
                    ? <path d="M16.6667 3.33331V13.3333H19.1667L15.8333 17.5L12.5 13.3333H15V3.33331H16.6667ZM10 15V16.6666H2.5V15H10ZM11.6667 9.16665V10.8333H2.5V9.16665H11.6667ZM11.6667 3.33331V4.99998H2.5V3.33331H11.6667Z" fill="currentColor"/>
                    : <path d="M15.8333 2.5L19.1667 6.66667H16.6667V16.6667H15V6.66667H12.5L15.8333 2.5ZM11.6667 15V16.6667H2.5V15H11.6667ZM11.6667 9.16667V10.8333H2.5V9.16667H11.6667ZM10 3.33333V5H2.5V3.33333H10Z" fill="currentColor"/>
                }
            </svg>
        </IconContainer>
    )
}

export { SortBlockArrowIcon };